import { wordpressImgToImgixURL } from 'Utilities';
import { TRUSTPILOT_REVIEW_COUNT, TRUSTPILOT_REVIEW_SEARCH_KEY } from 'Utilities/reviews';
import { WordpressGuideSummaryData } from 'Utilities/wordpress/@types';

import type { PromoCardTile } from '../../common/PromoCards/PromoCards.types';
import type { GuidePost, PromoCardTileBlock, StepItemBlock } from '../@types/landingPages';

// eslint-disable-next-line max-len
export const formatReviews = (title?: string) => (title?.trim() ? title.trim().replace(TRUSTPILOT_REVIEW_SEARCH_KEY, TRUSTPILOT_REVIEW_COUNT) : undefined);

const STEPS_IMAGE_WIDTH = 440 * 2;

export const mapStepsImages = (steps: StepItemBlock[] = []): StepItemBlock[] =>
  steps.map((step) => ({
    ...step,
    image: `${wordpressImgToImgixURL(step.image)}&w=${STEPS_IMAGE_WIDTH}&h=${STEPS_IMAGE_WIDTH}`,
  }));

const WP_PARENT_CATEGORY_CAR_BUYING_AND_SELLING_GUIDES = 32;
const WP_PARENT_CATEGORY_GUIDES_V2 = 9041;

const GUIDES_PARENT_PATHS: Record<number, string> = {
  [WP_PARENT_CATEGORY_CAR_BUYING_AND_SELLING_GUIDES]: '/sell-my-car/guides',
  [WP_PARENT_CATEGORY_GUIDES_V2]: '/guides',
};

const DEFAULT_GUIDES_PATH = '/sell-my-car/guides';

const MIN_PARAGRAPH_TEXT_LENGTH = 20;

const GUIDE_LINK_ORIGIN = 'https://blog.motorway.co.uk';

export const getGuideUrl = ({ post_name: slug, post_parent: parent }: GuidePost) =>
  `${GUIDES_PARENT_PATHS[parent] ?? DEFAULT_GUIDES_PATH}/${slug}`;

export const getFirstParagraphHtml = (content = '') => {
  const paragraphs = content.match(/<p\b[^>]*>[\s\S]*?<\/p>/gi) ?? [];

  return paragraphs.find(
    (paragraph) => paragraph.replace(/<[^<>]*>/g, '').replace(/&[^;]+;/g, ' ').trim().length >= MIN_PARAGRAPH_TEXT_LENGTH,
  ) ?? '';
};

export const normalizeWordpressDate = (date: string) => date.trim().replace(' ', 'T');

export const mapGuidesToSummaryData = (guides: GuidePost[] = []): WordpressGuideSummaryData[] =>
  guides.map((guide) => ({
    date: normalizeWordpressDate(guide.post_date),
    excerpt: { protected: false, rendered: getFirstParagraphHtml(guide.post_content) },
    id: guide.ID,
    link: `${GUIDE_LINK_ORIGIN}${getGuideUrl(guide)}`,
    menu_order: guide.menu_order,
    modified: normalizeWordpressDate(guide.post_modified),
    title: { rendered: guide.post_title },
  }));

const PROMO_CARD_IMAGE_WIDTH = 316 * 2;

const toPromoCardImageSrc = (url: string): string => {
  const imgixUrl = wordpressImgToImgixURL(url);
  return imgixUrl !== url ? `${imgixUrl}&w=${PROMO_CARD_IMAGE_WIDTH}` : imgixUrl;
};

export const mapPromoCardsTiles = (tiles: PromoCardTileBlock[] = []): PromoCardTile[] =>
  tiles.map(({ image, ...tile }) => ({
    ...tile,
    ...(image?.url
      ? {
        img: {
          alt: image.alt ?? '',
          src: { png: toPromoCardImageSrc(image.url) },
        },
      }
      : {}),
  }));
